var map = {
	"./icon_ai_brain.svg": 287,
	"./icon_brain_network.svg": 288,
	"./icon_calandar.svg": 289,
	"./icon_care.svg": 290,
	"./icon_collaboration_innovation.svg": 291,
	"./icon_dna.svg": 292,
	"./icon_dna_analysis.svg": 293,
	"./icon_doctor.svg": 294,
	"./icon_formulations.svg": 295,
	"./icon_hybrid_brain_ai.svg": 296,
	"./icon_lotion.svg": 297,
	"./icon_massage.svg": 298,
	"./icon_mental_idea.svg": 299,
	"./icon_mental_net.svg": 300,
	"./icon_mindfullness.svg": 301,
	"./icon_nutrition.svg": 302,
	"./icon_team.svg": 303,
	"./icon_world_experts.svg": 304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 286;